export default __webpack_public_path__ + "static/media/american-express.66a9295e.png";